const localeMap = { 'de': 'de-CH', 'fr': 'fr-CH' }
export function formatDate(dateStr, appLocale) {
    const localeMap = {
        'de': 'de-CH',
        'fr': 'fr-CH',
    };
    const locale = localeMap[appLocale] ?? appLocale;
    const date = new Date(dateStr);
    const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
    return date.toLocaleDateString(locale, options);
}

export function formatTime(ms) {
    let date = new Date();
    date.setTime(ms);
    const hours = date.getUTCHours().toString().padStart(2, 0);
    const minutes = date.getUTCMinutes().toString().padStart(2, 0);
    return `${hours}:${minutes} Uhr`;
}
